const size = {
    sm: 'px-3 py-[10px] text-body3-regular rounded-md min-h-[40px]',
    md: 'py-[14px] px-[15px] text-body1-regular min-h-[48px]',
    lg: 'py-[16px] px-[15px] text-body1-regular min-h-[56px]'
} as const;

const getVariantClasses = ({
    variant,
    color
}: {
    variant: 'fill' | 'outline' | 'light' | 'text' | 'disabled';
    color: 'primary' | 'secondary' | 'danger' | 'gray' | 'black' | 'warning';
}): string => {
    const base =
        'inline-flex items-center justify-center rounded-2xl transition-colors focus:outline-none font-semibold';

    const colorStyles = {
        primary: {
            fill: 'bg-primary-700 text-white hover:bg-primary-700',
            outline: 'bg-transparent border border-primary-700 text-primary-700 hover:bg-primary-700 hover:text-white',
            light: 'bg-primary-50 text-primary-700 hover:bg-primary-100',
            text: 'text-primary-700 border border-transparent hover:border-primary-700',
            disabled: 'bg-primary-300 text-white cursor-not-allowed pointer-events-none'
        },

        danger: {
            fill: 'bg-danger-600 text-white hover:bg-danger-700',
            outline: 'bg-transparent border border-danger-700 text-danger-700 hover:bg-danger-700 hover:text-white',
            light: 'bg-danger-50 text-danger-700 hover:bg-danger-100',
            text: 'text-danger-700 border border-transparent hover:border-danger-700',
            disabled: 'bg-danger-600 text-white opacity-50 cursor-not-allowed pointer-events-none'
        },

        gray: {
            fill: 'bg-gray-100 text-gray-700 hover:bg-gray-300',
            outline: 'bg-transparent border border-gray-600 text-gray-600',
            light: 'bg-gray-50 text-gray-600 hover:bg-gray-100',
            text: 'text-gray-700 border border-transparent hover:border-gray-600',
            disabled: 'bg-gray-100 text-gray-700 opacity-50 cursor-not-allowed pointer-events-none'
        },

        secondary: {
            fill: 'bg-secondary-600 text-white hover:bg-secondary-dark',
            outline: 'bg-transparent border border-secondary text-secondary hover:bg-secondary-100',
            light: 'bg-secondary-50 text-secondary-700',
            text: 'text-secondary-600',
            disabled: 'bg-secondary-600 text-white opacity-50 cursor-not-allowed pointer-events-none'
        },

        warning: {
            fill: 'bg-warning-50 text-warning-800 hover:bg-warning-600 hover:text-white',
            outline: 'bg-transparent border border-warning text-warning hover:bg-warning-100',
            light: 'bg-warning-50 text-warning-700',
            text: 'text-warning-600',
            disabled: 'bg-warning-50 text-warning-800 opacity-50 cursor-not-allowed pointer-events-none'
        },

        black: {
            fill: 'bg-secondary text-white hover:bg-secondary-dark',
            outline: 'bg-transparent border border-gray-400 text-gray-800 hover:border-gray-500',
            light: 'bg-secondary-50 text-secondary-700',
            text: 'text-secondary hover:no-underline',
            disabled: 'bg-secondary text-white opacity-50 cursor-not-allowed pointer-events-none'
        }
    };

    return `${base} ${colorStyles[color][variant]}`;
};

const buttonStyle = {
    size,
    getVariantClasses
};

export default buttonStyle;
